import React from 'react';

import { Typography } from '@forgeglobal/design-framework';
import useRepresentative from '@tcs/client-portal-common/hooks/useRepresentative';
import { Unicode } from '@tcs/common/utils/unicode';
import Spinner from '@tcs/common/components/atoms/Spinner';
import Header, { HeaderProps } from '.';
import { useStyles } from './style';

const spacer =
  Unicode.NonbreakingSpace.repeat(3) + '|' + Unicode.NonbreakingSpace.repeat(3);

type RepresentativeHeaderProps = Omit<HeaderProps, 'pageTitle'> & {
  representativeCode: string;
};

const RepresentativeHeader = ({
  representativeCode,
  ...headerProps
}: RepresentativeHeaderProps) => {
  const classes = useStyles();
  const { loading, data: representative } =
    useRepresentative(representativeCode);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Header {...headerProps}>
      <div data-test-id="title">
        <Typography variant="h4" data-test-id="titlePrimary">
          {representative?.name}
        </Typography>
        <Typography
          variant="h6"
          color="textSecondary"
          data-test-id="titleSecondary">
          <span> {`Representative Code: ${representativeCode}`}</span>
          {representative?.firmName && (
            <span
              className={classes.firmName}
              title={
                representative.firmName
              }>{`${spacer}Firm Name: ${representative.firmName}`}</span>
          )}
        </Typography>
      </div>
    </Header>
  );
};

export default RepresentativeHeader;
